export default {
  // sponsor: state => state.introduce.sponsors,
  sponsorSmall: state => state.sponsors.filter(item => item.crade == 2),
  sponsorLarge: state => state.sponsors.filter(item => item.crade == 1)
  ,
}
